import React from 'react';
import PropTypes from 'prop-types';

const Tag = ({ backgroundColor, color, title }) => {
    // default to white font
    const fontColor = (color) ? color : "#FFFFFF";
    // using inline styling here because these are used in a datatable that adds it's own styling
    return (
        <span className="tag" style={{ backgroundColor: backgroundColor, padding: "3px 5px 3px 5px", borderRadius: "2px", borderWidth: "1px", borderStyle: "solid", borderColor: "#1b71c83d" }}>
            <span style={{ color: fontColor, padding: 0 }}>{title}</span>
        </span>
        
    );
}

Tag.propTypes = {
    backgroundColor: PropTypes.string.isRequired,
    color: PropTypes.string,
    title: PropTypes.string.isRequired
};

export default Tag;